import React from 'react';
import { Route, RouteProps, Redirect } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import store from '../store';
import AuthService, { isAuthToken } from './Authentication/AuthService';
import { getUser } from './__queries__';

export const auth = new AuthService(store);

const GET_USER_ID = gql`
  query getUser {
    user {
      id
    }
  }
`;

const PrivateRoute = ({ component: Component, ...rest }: RouteProps) => {
  const { data, loading } = useQuery<getUser>(GET_USER_ID, { fetchPolicy: 'network-only' });

  const authToken = store.getState().authToken;
  const isValidToken = isAuthToken(authToken);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (Component && isValidToken && (loading || (!loading && data?.user))) {
          return <Component {...props} />;
        }
        return <Redirect to={{ pathname: '/', state: { from: props.location } }} />;
      }}
    />
  );
};

export default PrivateRoute;
